import { channelTypeInfo } from "../models/ChannelType";
import Consumer from "../models/Consumer";
import GroupAddress from "../models/GroupAdress";
import { getSignalTypeBundle, getSignalTypeBundleWithoutScene } from "../models/SignalBundles";

export default function generateAddressesForConsumer_3(consumer: Consumer, middleGroup: GroupAddress) {
  if (channelTypeInfo(consumer.channelType).isSupply) {
    return;
  }

  const signalTypeBundle = getSignalTypeBundleWithoutScene(consumer.channelType);
  for (const signalType of signalTypeBundle) {
    const consumerSignal = consumer.getOrCreateSignalByType(signalType);
    if (consumerSignal) {
      let groupAddress3 = consumerSignal.groupAddresses?.firstItem || consumerSignal.lastGroupAddresses?.firstItem;
      const name = state.settings.groupAddressNameGenerator.generateGroupAddressNameForConsumer(
        consumer,
        consumerSignal,
      );

      if (groupAddress3) {
        groupAddress3.name = name;

        const middleGroupOld = groupAddress3.parent as GroupAddress;
        if (middleGroupOld) {
          middleGroupOld.children.addWithoutUpdate(groupAddress3);
        }
      } else {
        groupAddress3 = GroupAddress.createNewGroupAddress({
          level: 3,
          name: name,
          parent: middleGroup,
        });

        console.log(`createNewGroupAddress: ${name} ${groupAddress3.fullAddress} `);
      }

      consumerSignal.addGroupAddress(groupAddress3);

      groupAddress3.signalTypeName = signalType.name;
      groupAddress3.isStatus = signalType.isStatus;
      groupAddress3.generatorObject = consumer;
    }
  }
}
